"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var errorDialog_1 = require("spry-react/Errors/errorDialog");
function Render404ErrorDialog(close) {
    return React.createElement(errorDialog_1.ErrorDialog, { close: close, singleTabText: "Page Not Found" },
        React.createElement("h2", null, "The page you are looking for is not here or cannot be accessed in this way"),
        "Some reasons you might be seeing this include:",
        React.createElement("ul", null,
            React.createElement("li", null, "The URL is not valid"),
            React.createElement("li", null, "The record has been deleted"),
            React.createElement("li", null, "You do not have access to this record"),
            React.createElement("li", null, "The page is not accessible through the URL bar"),
            React.createElement("li", null, "The page is not accessible through the browser's open in new tab/new window feature")));
}
exports.Render404ErrorDialog = Render404ErrorDialog;
